import { render, staticRenderFns } from "./Sys_BasicData.vue?vue&type=template&id=3d9f501d&"
import script from "./Sys_BasicData.vue?vue&type=script&lang=js&"
export * from "./Sys_BasicData.vue?vue&type=script&lang=js&"
import style0 from "./Sys_BasicData.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports